module.exports = __webpack_public_path__ + "static/media/suman-deb.ca93b1ca.jpg";